<template>
  <div class="login-card">
    <div class="text-center mb-3">
      <img src="/assets/image/logo/Logo-orange.svg" />
    </div>
    <b-form @submit="onSubmit" autocomplete="off">
      <b-form-group :label="$t('form_email_phone')" label-class="label-class" :invalid-feedback="invalidFeedback"
        :state="state">
        <div class="input-group">
          <b-form-input class="form-control bg-white px-5" v-model="name" :state="state" autocomplete="on" />
          <i class="fas fa-user input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text"></span>
          </div>
        </div>
      </b-form-group>
      <b-form-group :label="$t('form_password')" label-class="label-class" :invalid-feedback="invalidFeedback"
        :state="state">
        <div class="input-group m-0">
          <b-form-input autocomplete="on" class="form-control bg-white px-5" :type="`${showPass ? 'text' : 'password'}`"
            v-model="pass" :state="state" />
          <i class="fas fa-shield input-icon"></i>
          <div class="input-group-append">
            <span class="input-group-text py-0 bg-white" :style="state === false ? 'border-color: #dc3545' : ''"
              style="cursor: pointer" @click="showPass = !showPass">
              <img v-if="showPass" src="assets/image/icon/eye.svg" height="16px" />
              <img v-else src="assets/image/icon/eye-off.svg" height="16px" />
            </span>
          </div>
        </div>
      </b-form-group>
      <div class="text-danger mb-2" style="min-height: 24px;">{{ error }}</div>
      <b-button class="w-100 login-btn" type="submit">{{ $t('nav_login') }}</b-button>
      <p class="attribute w-100 text-center mx-auto my-2">
        <router-link class="attribute" to="/Authen/Forget">{{ $t('form_forgot') }}</router-link>
      </p>
      <p class="mention w-100 text-center mt-2 mb-3">
        {{ $t('form_not_acc') }}
        <router-link to="/Authen/Create" class="attribute">{{ $t('form_register') }}</router-link>
      </p>
    </b-form>
  </div>
</template>

<script>
import RepositoryFactory from "@/repository/factory";
const authCustomer = RepositoryFactory.get("authCustomer");
export default {
  data() {
    return {
      state: null,
      name: null,
      pass: null,
      showModal: false,
      error: "",
      showPass: false,
    };
  },
  computed: {
    invalidFeedback() {
      return this.$t('valid_enterAllRequiredInformation');
    },
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      if (this.name && this.pass) {
      } else {
        this.state = false;
      }
      if (this.state === false) return;
      let body = {
        UserName: this.name,
        UserPassword: this.pass,
        AppCode: "VGAS247",
      };
      let res = await authCustomer.LoginCustomer(body);
      if (res.status) {
        localStorage.setItem("server", res.data[0].ServerName);
        localStorage.setItem("token", res.data[0].Token);
        localStorage.setItem("user", JSON.stringify(res.data[0]));
        this.$bvModal.hide("login-modal");
        this.error = "";
        // this.$router.push('/')
        window.location.href = "/";
        // location.reload();
      } else {
        this.error = res.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-image {
  padding: 148px 0;
  background: url("/assets/image/vgas/login-bg.jfif") lightgray 50% / cover no-repeat;
}

.login-card {
  border-radius: var(--Border-radius-rounded-xl, 12px);
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(25px);
  padding: 16px;
  margin: 0 auto;
  max-width: 416px;
}

.login-btn {
  border-radius: 12px !important;
  background: var(--brand-color, #ff9500) !important;
}

.attribute {
  color: var(--System-Colors-Orange, #ff9500);
  /* text-14/font-semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 157.143% */
}

.input-icon {
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 20px;
  z-index: 9;
  transform: translateY(-50%);
  color: #6b6f80;
}
</style>